import * as yup from "yup";
import { requiredKanaAlpNum } from "../utility/ValidationUtilty";

export type Company = {
  id:string;
  displayId:string;
  name: string;
  nameKana: string
  managerName: string;
  managerNameKana: string;
  managerEmail: string;
  usersCount :number;
  createAt: Date;
  updateAt: Date;
  eventType?: Array<string>;
  deleteFlg: boolean;
}

export const initialCompany: Company = {
  id: "",
  displayId: "",
  name: "",
  nameKana: "",
  managerName: "",
  managerNameKana: "",
  managerEmail: "",
  usersCount: 0,
  createAt: new Date(),
  updateAt: new Date(),
  deleteFlg: false,
};

export const CompanyItemMaping = (data: any | undefined): Company => {
  data.createAt = new Date(data?.createAt?.seconds * 1000);
  data.updateAt = data?.updateAt !== null
    ? new Date(data?.updateAt.seconds * 1000)
    : new Date();
  return data;
}

export type Salt = {
  companiesId: string;
  createAt: Date;
  id: string;
  salt: string;
}

export const companySchema = yup.object({
  displayId: yup.string().required().length(8),
  name: yup.string().required(),
  nameKana: requiredKanaAlpNum,
  managerEmail: yup.string().email().required(),
  managerName: yup.string().required(),
  managerNameKana: requiredKanaAlpNum,
  usersCount: yup.number().myRequired(),
});
